import { Component } from '@angular/core';

@Component({
    selector: 'rwidget-related-card-personalize-aside',
    templateUrl: './related-card-personalize-aside.component.html',
    styleUrls: ['./related-card-personalize-aside.component.scss'],
})

export class RelatedCardPersonalizeAsideComponent {

}
